import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  FieldLabel,
  FieldValue,
  Title,
  ProfileImage,
  ProfileImageWrapper,
  Field,
} from "./ProfileInfoStyles";
import Avatar from "../../img/logged/avatar.png";
import ButtonGradient from "../ui/ButtonGradient";

import User from "../../img/form/user.png";
import Mail from "../../img/form/mail.png";
import Call from "../../img/form/call.png";
import Lock from "../../img/form/lock.png";
import { motion } from "framer-motion";
import { fadeUp } from "../../styles/animations";

interface UserData {
  name: string;
  lastName: string;
  artistName: string;
  email: string;
  phone: string;
}

const ProfileInfo = () => {
  const [user, setUser] = useState<UserData | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const data = localStorage.getItem("user_data");
    if (data) {
      setUser(JSON.parse(data));
    } else {
      setUser({
        name: "Matheus",
        lastName: "Iubel",
        artistName: "IUBL",
        email: "iubl@music.com",
        phone: "+55 (47) 99999-0000",
      });
    }
  }, []);

  if (!user) return <Title>Carregando...</Title>;

  return (
    <Container as={motion.div} initial="hidden" animate="visible">
      <Title as={motion.h1} variants={fadeUp} custom={0}>
        Meu Perfil
      </Title>

      <ProfileImageWrapper as={motion.div} variants={fadeUp} custom={1}>
        <ProfileImage src={Avatar} alt="Foto de perfil" />
      </ProfileImageWrapper>

      <Field as={motion.div} variants={fadeUp} custom={2}>
        <img src={User} alt="ícone usuário" />
        <FieldLabel>Nome: </FieldLabel>
        <FieldValue>{user.name}</FieldValue>
      </Field>

      <Field as={motion.div} variants={fadeUp} custom={3}>
        <img src={User} alt="ícone usuário" />
        <FieldLabel>Sobrenome: </FieldLabel>
        <FieldValue>{user.lastName}</FieldValue>
      </Field>

      <Field as={motion.div} variants={fadeUp} custom={4}>
        <img src={User} alt="ícone usuário" />
        <FieldLabel>Nome Artístico: </FieldLabel>
        <FieldValue>{user.artistName}</FieldValue>
      </Field>

      <Field as={motion.div} variants={fadeUp} custom={5}>
        <img src={Mail} alt="ícone email" />
        <FieldLabel>E-mail: </FieldLabel>
        <FieldValue>{user.email}</FieldValue>
      </Field>

      <Field as={motion.div} variants={fadeUp} custom={6}>
        <img src={Call} alt="ícone telefone" />
        <FieldLabel>Telefone: </FieldLabel>
        <FieldValue>{user.phone}</FieldValue>
      </Field>

      <motion.div variants={fadeUp} custom={7}>
        <ButtonGradient onClick={() => navigate("/edit-profile")}>
          Edite seu perfil
        </ButtonGradient>
      </motion.div>
    </Container>
  );
};

export default ProfileInfo;
